var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpciones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.88752 3.23808H18.6366C19.3894 3.23808 20.0002 2.6429 20.0002 1.90774C20.0002 1.17257 19.3894 0.577393 18.6366 0.577393H6.88752C6.13477 0.577393 5.52393 1.17257 5.52393 1.90774C5.52393 2.6429 6.13477 3.23808 6.88752 3.23808Z",
    fill: "#C3C3C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6366 6.52686H6.88752C6.13477 6.52686 5.52393 7.12203 5.52393 7.8572C5.52393 8.59237 6.13477 9.18754 6.88752 9.18754H18.6366C19.3894 9.18754 20.0002 8.59237 20.0002 7.8572C20.0002 7.12203 19.3894 6.52686 18.6366 6.52686Z",
    fill: "#C3C3C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.94272 0C0.709147 0 0 0.695336 0 1.90773C0 3.12012 0.708354 3.81623 1.94272 3.81623C3.17709 3.81623 3.88544 3.12089 3.88544 1.90773C3.88544 0.694563 3.17709 0 1.94272 0Z",
    fill: "#C3C3C3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.94272 9.76573C3.01566 9.76573 3.88544 8.91127 3.88544 7.85723C3.88544 6.8032 3.01566 5.94873 1.94272 5.94873C0.869786 5.94873 0 6.8032 0 7.85723C0 8.91127 0.869786 9.76573 1.94272 9.76573Z",
    fill: "#C3C3C3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.94272 11.8979C0.709147 11.8979 0 12.5933 0 13.8064C0 15.0196 0.708354 15.7142 1.94272 15.7142C3.17709 15.7142 3.88544 15.0188 3.88544 13.8064C3.88544 12.5941 3.17709 11.8979 1.94272 11.8979Z",
    fill: "#C3C3C3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6366 12.4763H6.88752C6.13477 12.4763 5.52393 13.0715 5.52393 13.8067C5.52393 14.5418 6.13477 15.137 6.88752 15.137H18.6366C19.3894 15.137 20.0002 14.5418 20.0002 13.8067C20.0002 13.0715 19.3894 12.4763 18.6366 12.4763Z",
    fill: "#C3C3C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpciones);
export default __webpack_public_path__ + "static/media/opciones.3170fe637d6eb882514159e76ce17d49.svg";
export { ForwardRef as ReactComponent };